<template>
  <div class="entity-badge">
    <div class="entity-badge__square">
      {{ initials }}
    </div>
    <div class="entity-badge__text">
      <div class="entity-badge__name">
        {{ name }}
      </div>
      <div
        v-if="meta"
        class="entity-badge__meta"
      >
        {{ meta }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseEntityBadge',
  props: {
    initials: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    meta: {
      type: [String, Number],
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.entity-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  &__square {
    width: 32px;
    height: 32px;
    border-radius: 7px;
    background: var(--v-primary-base);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    flex: none;
  }

  &__name {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.4;
    color: var(--v-textPrimary-base);
  }

  &__meta {
    font-size: 0.8rem;
    line-height: 1.4;
    color: var(--ds-color-black-055);
  }
}
</style>
